"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Interventi() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const projects = [{
    name: "HVAC Impianti",
    description: "Ottimizzazione termofluidodinamica e riqualificazione energetica",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/commercial_hvac_unit_roof.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/commercial_hvac_unit_roof.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/commercial_hvac_unit_roof.png-wvc-sizes",
    alt: "Impianto HVAC professionale per condizionamento aria e ventilazione",
    gridClasses: "md:col-start-1 md:col-end-8 md:mt-0",
    aspect: "aspect-[4/5]"
  }, {
    name: "Cappe Professionali",
    description: "Bonifica tecnica e ripristino standard igienico-funzionali",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/stainless_steel_kitchen_hood.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/stainless_steel_kitchen_hood.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/stainless_steel_kitchen_hood.png-wvc-sizes",
    alt: "Cappa professionale in acciaio inox con sistema di aspirazione",
    gridClasses: "md:col-start-9 md:col-end-13 md:mt-24",
    aspect: "aspect-[3/4]"
  }, {
    name: "Sistemi Aspirazione",
    description: "Ottimizzazione tecnica reti di estrazione e filtrazione industriale",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/industrial_air_filter_bank.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/industrial_air_filter_bank.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/industrial_air_filter_bank.png-wvc-sizes",
    alt: "Sistema di filtrazione aria per impianti HVAC industriali",
    gridClasses: "md:col-start-2 md:col-end-7 md:mt-16",
    aspect: "aspect-[5/4]"
  }, {
    name: "Ispezione Video",
    description: "Diagnostica robotizzata e mappatura critica dei condotti",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/hvac_technician_ppe_inspection.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/hvac_technician_ppe_inspection.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720548/img/hvac_technician_ppe_inspection.png-wvc-sizes",
    alt: "Tecnico specializzato in DPI durante intervento di ispezione e manutenzione",
    gridClasses: "md:col-start-8 md:col-end-13 md:-mt-8",
    aspect: "aspect-[4/5]"
  }];
  return <section data-section-id="5067" id="ambiti-di-intervento-specialistico" className="dark bg-background pt-32 pb-24 md:pb-32 overflow-hidden">
      <div className="container mx-auto px-6 md:px-10">
        
        <div ref={headerRef} className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-20 md:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="md:col-span-7">
            <p className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground mb-8">
              — 02 / Soluzioni Tecniche Specializzate
            </p>
            <h2 className="font-default font-medium text-5xl md:text-7xl lg:text-8xl leading-[0.95] text-foreground tracking-tighter">
              Eccellenza
              <br />
              Tecnica
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9 flex items-end">
            <p className="font-default text-lg md:text-xl leading-relaxed text-foreground/80">
              Interventi specialistici di riqualificazione igienico-funzionale per impianti aeraulici, cappe professionali e sistemi di estrazione, garantendo efficienza operativa e sicurezza normativa.
            </p>
          </div>
        </div>

        
        <div ref={gridRef} className={`relative grid grid-cols-1 md:grid-cols-12 gap-y-10 md:gap-y-16 transition-opacity duration-1000 ${gridVisible ? "opacity-100" : "opacity-0"}`}>
          {projects.map((project, i) => <div data-index={i} key={project.name} className={`group relative ${project.gridClasses} transition-all duration-1000 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <Link to="/TechnicalDivisionPage" className="block">
                <div className={`relative overflow-hidden rounded-lg ${project.aspect} bg-muted border border-border/50 shadow-2xl`}>
                  <img src={project.image} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.alt} loading="lazy" decoding="async" className={`absolute inset-0 w-full h-full object-cover transition-transform duration-[700ms] ease-out group-hover:scale-[1.03] ${project.name === "Ispezione Video" ? "brightness-125" : ""}`} />
                  
                  <div className="absolute bottom-5 left-5 md:bottom-6 md:left-6 right-5 md:right-6 flex items-end justify-between gap-4">
                    <div className="bg-background/50 backdrop-blur-sm rounded-lg px-4 py-3 md:px-5 md:py-4">
                      <h3 className="font-default font-medium text-xl md:text-2xl text-[#00153D] leading-none relative inline-block">
                        {project.name}
                        <span className="absolute left-0 -bottom-1 h-px w-0 bg-[var(--chart-2)] transition-all duration-500 ease-out group-hover:w-full" />
                      </h3>
                      <p className="font-default text-[10px] md:text-xs text-foreground/70 mt-2 max-w-[200px] leading-tight">
                        {project.description}
                      </p>
                    </div>
                    <div className="opacity-0 translate-x-[-4px] group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500 bg-background/85 backdrop-blur-sm rounded-lg px-3 py-2 md:px-4 md:py-3">
                      <span className="font-mono text-[10px] md:text-xs tracking-[0.2em] uppercase text-foreground inline-flex items-center gap-1.5 whitespace-nowrap">
                        <ArrowRight className="size-3 text-[#0099FF]" />
                        Dettagli
                      </span>
                    </div>
                  </div>
                </div>
              </Link>

              
              {i === 1 && <div className="hidden md:block absolute -left-20 lg:-left-24 top-1/2 -translate-y-1/2 pointer-events-none">
                  <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground inline-block" style={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)"
            }}>
                    — Scroll
                  </span>
                </div>}
            </div>)}
        </div>

        
        <div ref={ctaRef} className={`mt-20 md:mt-28 flex justify-end transition-all duration-1000 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Button asChild variant="outline" size="lg" className="rounded-lg border-foreground/40 bg-transparent text-foreground hover:bg-foreground hover:text-background px-8 py-6 h-auto font-mono text-xs tracking-[0.2em] uppercase transition-all duration-500">
            <Link to="/TechnicalInspectionPage">
              Richiedi Sopralluogo
              <ArrowRight className="ml-2 size-4 text-[#0099FF]" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}